"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Popover;

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _querySelectorContainsNode = _interopRequireDefault(require("@mapbox/query-selector-contains-node"));

var PopoverPrimitive = _interopRequireWildcard(require("@radix-ui/react-popover"));

var _styles = require("../utils/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

;
/**
 * Display a popover. The popover is positioned relative to an anchor element
 */

function Popover(_ref) {
  var _ref$coloring = _ref.coloring,
      coloring = _ref$coloring === void 0 ? 'light' : _ref$coloring,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'right' : _ref$placement,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'center' : _ref$alignment,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'medium' : _ref$padding,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$hasPointer = _ref.hasPointer,
      hasPointer = _ref$hasPointer === void 0 ? true : _ref$hasPointer,
      _ref$hideWhenAnchorIs = _ref.hideWhenAnchorIsOffscreen,
      hideWhenAnchorIsOffscreen = _ref$hideWhenAnchorIs === void 0 ? false : _ref$hideWhenAnchorIs,
      _ref$allowPlacementAx = _ref.allowPlacementAxisChange,
      allowPlacementAxisChange = _ref$allowPlacementAx === void 0 ? true : _ref$allowPlacementAx,
      _ref$clickOutsideClos = _ref.clickOutsideCloses,
      clickOutsideCloses = _ref$clickOutsideClos === void 0 ? true : _ref$clickOutsideClos,
      _ref$escapeCloses = _ref.escapeCloses,
      escapeCloses = _ref$escapeCloses === void 0 ? true : _ref$escapeCloses,
      _ref$getInitialFocus = _ref.getInitialFocus,
      getInitialFocus = _ref$getInitialFocus === void 0 ? function (e) {
    return e.preventDefault();
  } : _ref$getInitialFocus,
      _ref$offsetFromAnchor = _ref.offsetFromAnchor,
      offsetFromAnchor = _ref$offsetFromAnchor === void 0 ? 6 : _ref$offsetFromAnchor,
      passthroughProps = _ref.passthroughProps,
      onExit = _ref.onExit,
      children = _ref.children,
      content = _ref.content;

  var _getTheme = (0, _styles.getTheme)(coloring),
      background = _getTheme.background,
      borderColor = _getTheme.borderColor,
      color = _getTheme.color,
      fill = _getTheme.fill;

  var triggerRef = (0, _react.useRef)(null);
  var bodyClasses = (0, _classnames2.default)("".concat(background, " ").concat(borderColor, " ").concat(color, " border shadow-darken25 round"), _defineProperty({
    'px12 py12': padding === 'medium',
    'px12 py6': padding === 'small'
  }, "border border-1 border--".concat(borderColor), borderColor));

  var getContent = function getContent() {
    if (typeof content === 'function') {
      return content();
    }

    return content;
  };

  var onDown = function onDown(e) {
    // Don't call onExit if it wasn't provided.
    if (!onExit) {
      return;
    } // If event target contains the trigger element, assume onExit is handled
    // on its own so don't re-fire it.


    if (triggerRef.current && triggerRef.current.contains(e.target)) {
      return;
    } // Check if the event target contains the following data attribute. If it
    // does, do not call onExit.


    if ((0, _querySelectorContainsNode.default)('[data-popover-ignore-clicks]', e.target)) {
      return;
    }

    onExit();
  };

  return /*#__PURE__*/_react.default.createElement(PopoverPrimitive.Root, {
    open: active
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: triggerRef,
    style: {
      display: 'contents'
    }
  }, /*#__PURE__*/_react.default.createElement(PopoverPrimitive.Trigger, {
    asChild: true
  }, children)), /*#__PURE__*/_react.default.createElement(PopoverPrimitive.Portal, null, /*#__PURE__*/_react.default.createElement(PopoverPrimitive.Content, _extends({
    sideOffset: offsetFromAnchor,
    className: bodyClasses,
    onEscapeKeyDown: escapeCloses && onExit,
    onPointerDownOutside: clickOutsideCloses && onDown,
    onOpenAutoFocus: getInitialFocus,
    align: alignment,
    side: placement,
    sticky: 'always',
    hideWhenDetached: hideWhenAnchorIsOffscreen,
    avoidCollisions: allowPlacementAxisChange
  }, passthroughProps), getContent(), hasPointer && /*#__PURE__*/_react.default.createElement(PopoverPrimitive.Arrow, {
    width: 12,
    height: 6,
    offset: 6,
    fill: fill
  }))));
}

Popover.propTypes = {
  /**
   * The trigger element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Triggers the active state of the popover. When true, the popover appears.
   */
  active: _propTypes.default.bool.isRequired,

  /**
   * The popover content. This can either be a string, valid JSX, or a function
   * returning either.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,

  /**
   * Preferred placement of the popover in relation to the anchor.
   * Adjusted according to available space.
   */
  placement: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * `'center'`, `'start'`, `'end'` Alignment of the popover edge in relation to the trigger element.
   */
  alignment: _propTypes.default.oneOf(['center', 'start', 'end']),

  /**
   * `'light'`, `'dark'`, `'warning'`, or `'error'`.
   */
  coloring: _propTypes.default.oneOf(['light', 'dark', 'warning', 'error']),

  /**
   * `'medium'`, `'small'`, or `'none'`.
   */
  padding: _propTypes.default.oneOf(['medium', 'small', 'none']),

  /**
   * Whether or not the popover has a triangle pointer.
   */
  hasPointer: _propTypes.default.bool,

  /**
   * If `true`, the popover will hide when its anchor is scrolled offscreen.
   * By default, the popover will follow its anchor wherever it goes.
   *
   * If your anchor is within an internally scrolling area, you may want to
   * use `true`, so the popover doesn't existing in a disembodied state after
   * its anchor is scrolled away.
   */
  hideWhenAnchorIsOffscreen: _propTypes.default.bool,

  /**
   * If `false`, the popover is *not* allowed to change axes on the anchor when
   * modifying its position to fit available space. By default, popovers on the
   * `left` and `right`, for example, might change to `bottom` is there is
   * neither space on the left nor the right.
   */
  allowPlacementAxisChange: _propTypes.default.bool,

  /**
   * If `false`, clicking outside the popover will not close it.
   * By default, it does.
   */
  clickOutsideCloses: _propTypes.default.bool,

  /**
   * If `false`, hitting Escape will not close the popover. By default, it does.
   */
  escapeCloses: _propTypes.default.bool,

  /**
   * A function called when popover is dismissed. You need to use this callback
   * to remove the Popover from the rendered page.
   */
  onExit: _propTypes.default.func,

  /**
   * A function that returns a DOM node. Use to specify which element should
   * receive focus when popover is first rendered.
   */
  getInitialFocus: _propTypes.default.func,

  /**
   * Number of pixels by which the popover should be offset from its anchor.
   */
  offsetFromAnchor: _propTypes.default.number,

  /**
   * Props to pass directly to popover content options from `@radix-ui/react-popover`.
   */
  passthroughProps: _propTypes.default.object
};